export const CATEGORYSTATE = 'categoryState';

export const assetSummary = {
  URGENT: {
    color: '#F5841F',
    bg: '#FFF8F2',
    state: 'URGENT',
    todoBg: '#f4dcc7',
  },
  OUTOFDATE: {
    color: '#F5841F',
    bg: '#FFF8F2',
    state: 'OUTOFDATE',
    todoBg: '',
  },
  'URGENT-NC': {
    color: '#F5841F',
    bg: '#FFF8F2',
    state: 'URGENT-NC',
    todoBg: '#f4dcc7',
  },
  CRITICAL: {
    color: '#fd1f01',
    bg: '#fd1f01',
    state: 'CRITICAL',
    todoBg: '',
  },
  ATN_REQ: {
    color: '#F5841F',
    bg: '#FFF8F2',
    state: 'URGENT',
    todoBg: '',
  },
  NODATA: {
    color: '#A6A6A6',
    bg: '#F7F8F9',
    state: 'NODATA',
    todoBg: '',
  },
  'NODATA-INV': {
    color: '#A6A6A6',
    bg: '#F7F8F9',
    state: 'NODATA-INV',
    todoBg: '',
  },
  'NOT-COMM': {
    color: '#A6A6A6',
    bg: '#F7F8F9',
    state: 'NODATA',
    todoBg: '',
  },
  HOLD: {
    color: '#A6A6A6',
    bg: '#F7F8F9',
    state: 'NODATA',
    todoBg: '',
  },
  GOOD: {
    color: '#8DC63F',
    bg: '#F8FCF4',
    state: 'GOOD',
    todoBg: '',
  },
  UPTODATE: {
    color: '#8DC63F',
    bg: '#F8FCF4',
    state: 'UPTODATE',
    todoBg: '',
  },
  NONE: {
    color: '#8DC63F',
    bg: '#F8FCF4',
    state: 'GOOD',
    todoBg: '',
  },
  PLAN: {
    color: '#FFE552',
    bg: '#FFFEF5',
    state: 'PLAN',
    todoBg: '#f8f1c3',
  },
  UPDAVBL: {
    color: '#FFE552',
    bg: '#FFFEF5',
    state: 'UPDAVBL',
    todoBg: '',
  },
  'NOT-CONN': {
    color: '#8FAADC',
    bg: '#F9FCFE',
    state: 'NOT-CONN',
    todoBg: '',
  },
  'NOT-CONN-INV': {
    color: '#8FAADC',
    bg: '#F9FCFE',
    state: 'NOT-CONN-INV',
    todoBg: '',
  },
  'ATN-REQ': {
    color: '#F5841F',
    bg: '#FFF8F2',
    state: 'URGENT',
    todoBg: '',
  },
  GAP: {
    color: '#C4F032',
    bg: '#FFF8F2',
    state: 'GAP',
    todoBg: '',
  },
};

export const availableAsset = ['GOOD', 'URGENT', 'PLAN', 'NOT-CONN', 'NODATA'];
export const opportunityTrendAsset = ['URGENT', 'PLAN'];
export const legendArr = [
  'GOOD',
  'URGENT',
  'CRITICAL',
  'PLAN',
  'NOT-CONN',
  'NODATA',
];

export const equipmentStatusForReports = [
  'URGENT',
  'NOT-CONN',
  'NODATA',
  'GOOD',
  'PLAN',
];

export const equipmentStatusForMaintenanceReports = [
  'URGENT',
  'PLAN',
  'NODATA',
  'GOOD',
  'NOT-CONN',
];

export const sortOrder = Object.freeze({
  GOOD: 0,
  URGENT: 1,
  CRITICAL: 2,
  PLAN: 3,
  'NOT-CONN': 4,
  NODATA: 5,
  ONB: 6,
  CONN: 7,
});

export const INVENTORY_ASSET_SUM = [
  'UPTODATE',
  'OUTOFDATE',
  'UPDAVBL',
  'NODATA-INV',
  'ONB-INV',
  'NOT-CONN-INV',
  'CONN-INV',
];

export const sortOrderInventory = Object.freeze({
  UPTODATE: 0,
  OUTOFDATE: 1,
  UPDAVBL: 2,
  'NOT-CONN-INV': 3,
  'NODATA-INV': 4,
  'ONB-INV': 5,
  'CONN-INV': 6,
});

export const INVENTORY_LEGEND_COLOR_MAP = {
  GOOD: '#8DC63F',
  UPTODATE: '#8DC63F',
  NODATA: '#A6A6A6',
  'NODATA-INV': '#A6A6A6',
  'NOT-CONN': '#8FAADC',
  'NOT-CONN-INV': '#8FAADC',
  URGENT: '#F5841F',
  OUTOFDATE: '#F5841F',
  PLAN: '#FFE552',
  UPDAVBL: '#FFE552',
};

export const EXCLUDED_STATUS = [
  'CRITICAL',
  'ONB',
  'CONN',
  'ONB-INV',
  'CONN-INV',
];

export const DEFAULT_ASSET_FILTERS = ['Bavg', 'Avg', 'Good', 'Others'];

export const availableInventoryAsset = [
  'UPTODATE',
  'OUTOFDATE',
  'UPDAVBL',
  'NODATA-INV',
  'NOT-CONN-INV',
];

export const ASSET_FILTER_MAP = {
  OUTOFDATE: 'Bavg',
  UPDAVBL: 'Avg',
  UPTODATE: 'Good',
  'NODATA-INV': 'Others',
  'NOT-CONN-INV': 'Others',
};

export const colorVariations = {
  Bavg: '#f4811d',
  Avg: '#ffe551',
  Good: '#8fc740',
  Null: '#a9a9a9',
  NullN: '#a9a9a9',
};

export const stageColor = {
  inprogress: {
    bgColor: '#ffc107',
  },
  urgent: {
    bgColor: '#FFC000',
  },
  plan: {
    bgColor: '#FCFC01',
  },
  hold: {
    bgColor: '#AEAEAE',
  },
  none: {
    bgColor: '#88C457',
  },
  open: {
    bgColor: 'rgba(140, 140, 140, 0.6)',
  },
  closed: {
    bgColor: 'rgb(76, 175, 80)',
  },
  confirmed: {
    bgColor: '#00968833',
    border: `1px solid`,
  },
  empty: { bgColor: '#ECECEC' },
};

export const defaultStatesForLegends = [
  { id: 'URGENT', dn: 'URGENT' },
  { id: 'ONB', dn: 'Onboarded' },
  { id: 'CONN', dn: 'Connected' },
  { id: 'NODATA', dn: 'No data' },
  { id: 'PLAN', dn: 'PLAN' },
  { id: 'GOOD', dn: 'GOOD' },
  { id: 'NOT-CONN', dn: 'Yet to connect' },
  { id: 'CRITICAL', dn: 'CRITICAL' },
];

export const insightStatus = { 'NOT-COMM': 'NOT-COMM' };

export const sortOrderForSiteSummaryReport = Object.freeze({
  URGENT: 0,
  'NOT-CONN': 1,
  NODATA: 2,
  GOOD: 3,
  PLAN: 4,
});

export const EXCLUDED_STATE_FOR_FILTER = ['CONN', 'ONB'];

export const urgencyArrObj = {
  AVAILABILITY: 'AVAILABILITY',
  CRITICAL: 'CRITICAL',
  URGENT: 'URGENT',
  GOOD: 'GOOD',
};

export const allAssets = 'All';

export const filterState = Object.freeze({
  GOOD: false,
  NODATA: false,
  'NOT-CONN': false,
  PLAN: false,
  URGENT: false,
  CRITICAL: false,
  [CATEGORYSTATE]: false,
});

export const inventoryFilterState = Object.freeze({
  UPTODATE: false,
  OUTOFDATE: false,
  UPDAVBL: false,
  'NODATA-INV': false,
  'NOT-CONN-INV': false,
  [CATEGORYSTATE]: false,
});

export const bundleInsightOrder = ['EPI', 'EII'];
